import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Pipe, PipeTransform } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { finalize, first } from "rxjs/operators";
import { DomSanitizer } from "@angular/platform-browser";
import { NgxSpinnerService } from "ngx-spinner";
import { AngularEditorConfig } from "@kolkov/angular-editor";

import { FormIsValidDTO } from "src/app/parametrage/core/model/form-is-valid-dto";
import { FormulaireService } from "src/app/parametrage/core/service/formulaire.service";
import { ExecuterAllTask } from "src/app/mon-portefeuille/core/model/executer-all-task";
import { TaskService } from "src/app/mon-portefeuille/core/service/task.service";

import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { LettreNotification } from "src/app/core/services/business/model/lettre-notification";
import { Request } from "src/app/parametrage/core/model/request";
import { Corporate } from "src/app/parametrage/core/model/corporate";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { CorporateService } from "src/app/corporate/core/service/corporate.service";
import { LettreNotificationService } from "src/app/core/services/business/service/lettre-notification.service";
import { FormAddConditionComponent } from "../../modal/form-add-condition/form-add-condition.component";
import { FormEditConditionComponent } from "../../modal/form-edit-condition/form-edit-condition.component";
import { EditCreditModalComponent } from "../../modal/edit-credit-modal/edit-credit-modal.component";
import { ReportViewerModalComponent } from "src/app/formulaire/modal/viewer/report-viewer-modal/report-viewer-modal.component";
import { TaskDocument } from "src/app/parametrage/core/model/task-document";
import { SubItemCheckedDTO } from "src/app/core/services/business/model/subItem-checked-dto";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";
import { TaskDocumentService } from "src/app/parametrage/core/service/task-document.service";
import { UploadInRapportComponent } from "src/app/formulaire/modal/upload-in-rapport/upload-in-rapport.component";
import { ConditionProfessionnel } from "src/app/professionnel/core/model/condition-professionnel";
import { ProfessionnelItem } from "src/app/professionnel/core/model/professionnel-item";
import { ProfessionnelItemService } from "src/app/professionnel/core/service/professionnel-item.service";
import { ConditionProfessionnelService } from "src/app/professionnel/core/service/condition-professionnel.service";
import { ReportingProfessionnelService } from "src/app/reporting/core/service/reporting-professionnel.service";

interface Alert {
  type: string;
  message: string;
}

@Component({
  selector: "app-form-generation-lettre-notification",
  templateUrl: "./form-generation-lettre-notification.component.html",
  styleUrls: ["./form-generation-lettre-notification.component.scss"],

  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //
})
export class FormGenerationLettreNotificationComponent implements OnInit {
  alerts: Alert[] = [];

  requestId: string;
  taskId: string;

  checkFormDTO: FormIsValidDTO;
  command: ExecuterAllTask = new ExecuterAllTask();

  pressButton: Boolean = false;
  form: FormGroup;

  name = "Angular 6";
  htmlContent = "";

  lettreNotification: LettreNotification;
  request: Request;
  corporate: Corporate;

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "8rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "no",
    defaultParagraphSeparator: "p",
    defaultFontName: "Arial",
    toolbarHiddenButtons: [["bold"]],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };

  conditions: ConditionProfessionnel[];
  conditionArray: Array<ConditionProfessionnel[]> = [];
  items: ProfessionnelItem[];
  displayedStudentsColumnsList: string[] = [
    "id",
    "produit.typeCredit.label",
    "produit.label",
    "montant",
    "actions",
  ];

  documents: TaskDocument[];
  documentsObligatoire: TaskDocument[];
  fichiers: SubItemCheckedDTO[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public sanitizer: DomSanitizer,
    private _formulaireService: FormulaireService,
    private _taskService: TaskService,
    private _requestService: RequestService,
    private _corporateService: CorporateService,
    private _lettreNotificationService: LettreNotificationService,
    private _professionnelItemService: ProfessionnelItemService,
    private _conditionService: ConditionProfessionnelService,
    private _reportingProfessionnelService: ReportingProfessionnelService,
    private _taskDocumentService: TaskDocumentService,
    private _gestionFichierService: GestionFichierService
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      lieuEmission: [null, Validators.compose([Validators.required])],
      dateEmission: [null, Validators.compose([Validators.nullValidator])],
      reference: [null, Validators.compose([Validators.required])],
      autre: [null, Validators.compose([Validators.required])],
      objet: [null, Validators.compose([Validators.required])],
      civiliteDemandeur: [null, Validators.compose([Validators.required])],
      dateDemande: [null, Validators.compose([Validators.required])],
      duree: [null, Validators.compose([Validators.required])],
      delai: [null, Validators.compose([Validators.required])],
      mention: [null, Validators.compose([Validators.required])],
      expiration: [null, Validators.compose([Validators.required])],
      piedPage: [null, Validators.compose([Validators.required])],

      commentaire: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.requestId = params["requestId"];
      this.taskId = params["taskId"];
      this.checkIfFormIsValid(this.taskId);
      this.getLettreNotificationByrequestId(this.requestId);
      this.getListProfessionnelItemByRequest(this.requestId);
      //this.getRapportsClient(this.requestId);
      this.getTaskDocumentsNotUploadedByTaskId(this.taskId);
    });
  }

  checkIfFormIsValid(taskId) {
    this._formulaireService.checkForm(taskId).subscribe(
      (data) => {
        this.checkFormDTO = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  executeTask(): void {
    this.command.taskId = this.taskId;
    this.command.requestId = this.requestId;
    this.command.messageText = this.htmlContent;

    this.pressButton = true;

    this.spinner.show();
    this._taskService
      .executerAllTask(this.command)
      .pipe(
        finalize(() => {
          this.spinner.hide();
        })
      )
      .subscribe(
        (data) => {
          this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
        },
        (error) => {
          console.log(error);
        }
      );
  }

  cancel(): void {
    this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
  }

  getLettreNotificationByrequestId(requestId) {
    this._lettreNotificationService
      .getLettreNotificationByrequestId(requestId)
      .subscribe(
        (data) => {
          this.lettreNotification = data;

          this.getRequestById(this.requestId);
          this.getCorporateByRequestId(this.requestId);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getCorporateByRequestId(requestId) {
    this._corporateService.getCorporateByRequestId(requestId).subscribe(
      (data) => {
        this.corporate = data;
        if (this.lettreNotification.civiliteDemandeur == null) {
          this.form.controls["civiliteDemandeur"].setValue(
            this.corporate.civilite
          );
        }
        if (this.lettreNotification.piedPage == null) {
          this.form.controls["piedPage"].setValue(
            "Notification " + this.corporate.corporateName
          );
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        this.request = data;

        
        if (this.lettreNotification.dateEmission == null) {
          this.form.controls["lieuEmission"].setValue("Abidjan");
        }

        if (this.lettreNotification.dateEmission == null) {
          this.form.controls["civiliteDemandeur"].setValue("Monsieur / Madame, ");
        }

        if (this.lettreNotification.dateEmission == null) {
          this.form.controls["duree"].setValue("(03) mois");
        }


        if (this.lettreNotification.dateEmission == null) {
          this.form.controls["dateEmission"].setValue(" ");
        }

        if (this.lettreNotification.dateDemande == null) {
          this.form.controls["dateDemande"].setValue(
            this.request.dateReceptionDossier
          );
        }

        //
        if (this.lettreNotification.autre == null) {
          this.form.controls["autre"].setValue("/-)");
        }

        if (this.lettreNotification.reference == null) {
          this.form.controls["reference"].setValue(
            "_____/ Banque Populaire de Côte d’Ivoire /DG/DC/SAD/sad/2020"
          );
        }

        if (this.lettreNotification.objet == null) {
          this.form.controls["objet"].setValue("Notification de crédit");
        }

        if (this.lettreNotification.mention == null) {
          this.form.controls["mention"].setValue("Bon pour Accord");
        }
        //
      },
      (error) => {
        console.log(error);
      }
    );
  }

  putLettreNotification(): void {
    this.alerts = [];
    this._lettreNotificationService
      .putLettreNotification(this.lettreNotification)
      .pipe(first())
      .subscribe(
        (data) => {
          this.alerts.push({
            type: "success",
            message: "Les modifications ont été enregistrées",
          });
        },
        (error) => {
          console.log(error);

          this.alerts.push({
            type: "danger",
            message: "Les modifications n'ont pas été enregistrées",
          });
        }
      );
  }

  getListProfessionnelItemByRequest(requestId) {
    this._professionnelItemService
      .getListProfessionnelItemByRequest(requestId)
      .subscribe(
        (data) => {
          this.items = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  updateCredit(professionnelItemId) {
    const modalRef = this.modalService.open(EditCreditModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.professionnelItemId = professionnelItemId;
    modalRef.componentInstance.workflowCode =
      this.checkFormDTO.request.workflow.code;

    modalRef.result.then(
      (data) => {
        // on close
        this.getListProfessionnelItemByRequest(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  getConditionProfessionnelsByProfessionnelItemId(professionnelItemId) {
    this._conditionService
      .getConditionProfessionnelsByProfessionnelItemId(professionnelItemId)
      .subscribe(
        (data) => {
          this.conditions = data;
          this.conditionArray[professionnelItemId] = this.conditions;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  AddCondition(professionnelItemId) {
    const modalRef = this.modalService.open(FormAddConditionComponent, {
      centered: true,
    });
    modalRef.componentInstance.professionnelItemId = professionnelItemId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getConditionProfessionnelsByProfessionnelItemId(
          professionnelItemId
        );
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  EditCondition(conditionId, professionnelItemId) {
    const modalRef = this.modalService.open(FormEditConditionComponent, {
      centered: true,
    });
    modalRef.componentInstance.conditionId = conditionId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getConditionProfessionnelsByProfessionnelItemId(
          professionnelItemId
        );
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  deleteCondition(conditionId, professionnelItemId) {
    this._conditionService
      .deleteConditionProfessionnel(conditionId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.getConditionProfessionnelsByProfessionnelItemId(
            professionnelItemId
          );
        },
        (error) => {
          console.log(error);
        }
      );
  }

  Apercu() {
    this._reportingProfessionnelService
      .lettreNotification(this.requestId)
      .subscribe((blob) => {
        const modalRef = this.modalService.open(ReportViewerModalComponent, {
          size: "lg",
          backdrop: "static",
          centered: true,
        });

        modalRef.componentInstance.destination = blob;

        modalRef.result.then(
          (data) => {},
          (reason) => {}
        );
      });
  }

  downloadLettre(exportType) {
    this._reportingProfessionnelService
      .lettreNotification(this.requestId)
      .subscribe((blob) => {
        let fileUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = fileUrl;

        if (exportType == "PDF") {
          link.setAttribute("download", "lettre_notification.pdf");
        } else {
          link.setAttribute("download", "lettre_notification.docx");
        }

        document.body.appendChild(link);
        link.click();
      });
  }

  getRapportsClient(requestId, filenameWithoutExtension) {
    this._gestionFichierService
      .getRapportsClient(requestId, filenameWithoutExtension)
      .subscribe(
        (data) => {
          this.fichiers = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getTaskDocumentsNotUploadedByTaskId(taskId) {
    this._taskDocumentService
      .getTaskDocumentsNotUploadedByTaskId(taskId)
      .subscribe(
        (data) => {
          this.documents = data.sort((a, b) => (a.label > b.label ? 1 : -1));
          this.documentsObligatoire = this.documents.filter(
            (t) => t.obligatoire == true
          );
          if (this.documents.length == 1) {
            this.getRapportsClient(this.requestId, this.documents[0].code);
          } else {
            this.getRapportsClient(this.requestId, "lettre_notification");
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  upload(codeDocument) {
    const modalRef = this.modalService.open(UploadInRapportComponent, {
      centered: true,
    });

    modalRef.componentInstance.requestId = this.requestId;
    modalRef.componentInstance.codeDocument = codeDocument;
    if (codeDocument != "AUTRE") {
      modalRef.componentInstance.displayname = codeDocument;
    } else {
      modalRef.componentInstance.displayname = null;
    }

    modalRef.result.then(
      (data) => {
        // on close
        this.getTaskDocumentsNotUploadedByTaskId(this.taskId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  downloadFile(subitemId: string, filename: string) {
    this._gestionFichierService.downloadFile(subitemId).subscribe((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }
}
